import { LifecycleStatus } from "@app/shared/models/enrichment-list.model";

export type PriceStatusTab = "all" | "designed" | "live" | "rejected";

export interface PriceStatusTabSpec {
  value: PriceStatusTab;
  label: string;
  statuses: readonly LifecycleStatus[];
  tooltip: string;
}

export const PRICE_STATUS_TAB: {
  readonly [K in PriceStatusTab]: PriceStatusTabSpec & { value: K };
} = {
  all: {
    value: "all",
    label: "All",
    statuses: [],
    tooltip: "Every price on this channel, whatever its status",
  },
  designed: {
    value: "designed",
    label: "Designed",
    statuses: ["designed"],
    tooltip: "Prices ready to publish on this channel",
  },
  live: {
    value: "live",
    label: "Live",
    statuses: ["active", "launched"],
    tooltip: "Prices on sale on this channel, active or launched",
  },
  rejected: {
    value: "rejected",
    label: "Rejected",
    statuses: ["rejected"],
    tooltip: "Prices rejected on this channel",
  },
};

export const PRICE_STATUS_TABS: readonly PriceStatusTabSpec[] = [
  PRICE_STATUS_TAB.all,
  PRICE_STATUS_TAB.designed,
  PRICE_STATUS_TAB.live,
  PRICE_STATUS_TAB.rejected,
];

export interface StatusTabQuery {
  priceLifecycleStatus: string;
  isEnriched: true;
}

export function statusTabQuery(tab: PriceStatusTabSpec): StatusTabQuery | null {
  if (tab.statuses.length === 0) return null;
  return { priceLifecycleStatus: tab.statuses.join(","), isEnriched: true };
}
